import { Injectable, computed, inject, signal } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { TenantConfig } from '../models/tenant.model';
import { firstValueFrom } from 'rxjs';
import { AuthStore } from '../../auth/store/auth.store';
import { TenantIDPInfo } from '@shared/index';
 
@Injectable({

  providedIn: 'root'

})

export class TenantService {
 
  private http = inject(HttpClient);
  private authStore=inject(AuthStore);
 
  // private  tenant = signal<TenantConfig | null>(null);

  // readonly tenantConfig=computed(()=> this.tenant());
 
  // async loadTenant(tenant: string) {
 
  //   // const config = await this.http

  //   //   .get<TenantConfig>(`/api/tenant/config?tenant=${tenant}`)

  //   //   .toPromise();
 
  //   // this.tenant.set(config!);
    
  //   try {
  //       // const config = await firstValueFrom(
  //       // this.http.get<TenantConfig>('/api/tenant/config', { params: { tenant } })
  //       // );
  //       const config:TenantConfig={
  //           tenantId:'cognizant1-d31r6',
  //           providers:[{
  //               label:'Sign in with google',
  //               type:'Google'
  //           }]
  //       }
  //       this.tenant.set(config);
  //   } catch (err) {
  //       console.error('Failed to load tenant config', err);
  //       this.tenant.set(null);
  //   }
  // }
  async loadTenant(tenant: TenantIDPInfo | null): Promise<void> {
    let identity_providers=tenant?.identity_providers ?? [];
    try {
      // Simulate async work with a promise
      const config: TenantConfig = {
        firebaseTenantId: tenant?.firebase_tenant_id ?? '',
        backendTenantId:tenant?.tenant_id ?? '',

        providers: [...new Set(identity_providers)].map(idp=> ({
          label:"Sign in With "+idp,
          type:idp.toLowerCase().replace(/\b\w/g, s => s.toUpperCase()),

        }))
      };
  
      // Add artificial delay to prove Angular waits
      await new Promise(resolve => setTimeout(resolve, 1000));
  
      this.authStore.setTenantInfo(config);
      console.log("Tenant loaded:", config);
    } catch (err) {
      console.error('Failed to load tenant config', err);
      this.authStore.setTenantInfo(null);
    }
  }
 
}
 